import React from "react";
import MilaShowcase01 from "../../../assets/images/technology/showcase-carousel/tech_page_01.mp4";
import MilaShowcase02 from "../../../assets/images/technology/showcase-carousel/tech_page_02.mp4";
import MilaShowcase03 from "../../../assets/images/technology/showcase-carousel/tech_page_03.mp4";
import MilaShowcase04 from "../../../assets/images/technology/showcase-carousel/tech_page_04.mp4";

import MilaShowcase01Sm from "../../../assets/images/technology/showcase-carousel/tech_page_01_sm.mp4";
import MilaShowcase02Sm from "../../../assets/images/technology/showcase-carousel/tech_page_02_sm.mp4";
import MilaShowcase03Sm from "../../../assets/images/technology/showcase-carousel/tech_page_03_sm.mp4";
import MilaShowcase04Sm from "../../../assets/images/technology/showcase-carousel/tech_page_04_sm.mp4";

import footerImage01 from "../../../assets/images/technology/showcase-carousel/screen-01.png";
import footerImage02 from "../../../assets/images/technology/showcase-carousel/screen-02.png";
import footerImage03 from "../../../assets/images/technology/showcase-carousel/screen-03.png";
import footerImage04 from "../../../assets/images/technology/showcase-carousel/screen-04.png";

const showcaseCarouselData = [
  {
    video: MilaShowcase01,
    videoSm: MilaShowcase01Sm,
    image: footerImage01,
    description: (
      <>
        <p>
          Mila is the first purifier to detect presence in the room and deep
          clean when you aren&apos;t around—increasing cleaning power in your
          home by 40%. more effective cleaning power.
        </p>
      </>
    ),
    title: (
      <>
        <span> Mila quiets down when</span> <br />{" "}
        <span>you&apos;re around.</span>
      </>
    ),
    titleSm: (
      <>
        <span> Mila quiets down when</span> <br />{" "}
        <span>you&apos;re around.</span>
      </>
    ),
  },
  {
    video: MilaShowcase02,
    videoSm: MilaShowcase02Sm,
    image: footerImage02,
    description: (
      <>
        <p>
          Mila is the first purifier to detect presence in the room and deep
          clean when you aren&apos;t around—increasing cleaning power in your
          home by 40%. more effective cleaning power.
        </p>
      </>
    ),
    title: (
      <>
        <span>And deep cleans</span> <span>when no one is</span> <br />{" "}
        <span>listening.</span>
      </>
    ),
    titleSm: (
      <>
      <span>And deep cleans</span> <br />{" "} <span>when no one is</span> <br />{" "}
      <span>listening.</span>
      </>
    ),
  },
  {
    video: MilaShowcase03,
    videoSm: MilaShowcase03Sm,
    image: footerImage03,
    description: (
      <>
        <p>
          Kick off your bedtime routine with Turndown Service and let Mila deep
          clean the air an hour before you hit the hay so your space is calm,
          clear, and ready for rest.
        </p>
      </>
    ),
    title: (
      <>
        <span> Mila turns down</span> <br /> <span>your bedroom like </span>{" "}
        <br />
        <span>a pro.</span>
      </>
    ),
    titleSm: (
      <>
        <span>Mila turns down your</span> <br />{" "}
        <span>bedroom like a pro.</span>
      </>
    ),
  },
  {
    video: MilaShowcase04,
    videoSm: MilaShowcase04Sm,
    image: footerImage04,
    description: (
      <>
        <p>
          Prefer total hush? Sleep Mode dims the lights, softens the fan, and
          keeps the air quietly clean &apos;til morning.
        </p>
      </>
    ),
    title: (
      <>
        <span>Then stays</span> <br /> <span>bedside, gently</span> <br />
        <span>cleaning while</span> <br /> <span> you sleep.</span>
      </>
    ),
    titleSm: (
      <>
        <span> Then stays bedside, gently</span> <br />{" "}
        <span>cleaning while you sleep.</span>
      </>
    ),
  },
];

export default showcaseCarouselData;
